// app/permissions/permissions.tsx

export const PERMISSION = {
  CREATE: 1,
  READ: 2,
  UPDATE: 4,
  DELETE: 8,
  FULL: 15,
} as const;

// Module indices — keep in sync with the Go backend constants.
export const MODULE = {
  User:            1,
  Role:            2,
  Privilege:       3,
  Personel:        4,
  // 5 (Gudang) is deprecated — no routes check it
  Aset:            6,
  MatMasuk:        7,
  MatKeluar:       8,
  Notif:           9,
  Klasifikasi:     10,
  Dashboard:       11,
  AuditTrail:      12,
  DocFile:         13,
  MatEdit:         14,
  MatMasukGlobal:  15,
  MatKeluarGlobal: 16,
  MatEditGlobal:   17,
  AsetGlobal:      18,
  Benchmark:       19,
  Identifikasi:       20,
  IdentifikasiGlobal: 21,
  MatPinjam:          22,
  MatPengembalian:    23,
} as const;

export const NUM_MODULES = 23;

/**
 * Check whether permsStr grants the required CRUD bits for a given module.
 *
 * @param permsStr  hex-encoded permission string (one nibble per module, 1-based)
 * @param module    1-based module index (use MODULE.X constants)
 * @param crud      bitmask of required bits (default: READ)
 */
export function hasPerm(
  permsStr: string,
  module: number,
  crud: number = PERMISSION.READ
): boolean {
  if (module < 1 || module > NUM_MODULES || permsStr.length < module) return false;
  const nibble = parseInt(permsStr[module - 1], 16);
  if (isNaN(nibble)) return false;
  return (nibble & crud) === crud;
}
